module.exports = __webpack_public_path__ + "img/more_bg.0bb87ab4.png";